import React from 'react';
import { Handshake, ClipboardList, FileText, PenTool, Scale, CheckCircle, Clock, Pin } from 'lucide-react';
import { FormRenderResponse } from '../../types/consent';
import '../../styles/wizard-steps.css';

interface WelcomeStepProps {
  formData: FormRenderResponse;
  onNext: () => void;
}

const WelcomeStep: React.FC<WelcomeStepProps> = ({ formData, onNext }) => {
  const templateCount = formData.templates.length;
  const estimatedMinutes = templateCount * 2; // 2 min per template

  return (
    <div className="wizard-step welcome-step">
      <div className="step-icon"><Handshake size={24} /></div>
      <h1 className="step-title">Consent Request</h1>
      <p className="step-subtitle">
        Welcome! We need your informed consent to proceed.
      </p>

      <div className="overview-card">
        <h3><ClipboardList size={20} style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} /> What You Will Do:</h3>
        <ul className="overview-list">
          <li>
            <span className="icon"><FileText size={20} /></span>
            <span>Review {templateCount} consent {templateCount === 1 ? 'document' : 'documents'}</span>
          </li>
          <li>
            <span className="icon"><PenTool size={20} /></span>
            <span>Provide your signature</span>
          </li>
          <li>
            <span className="icon"><Scale size={20} /></span>
            <span>Learn about your legal rights</span>
          </li>
          <li>
            <span className="icon"><CheckCircle size={20} /></span>
            <span>Submit your consent</span>
          </li>
        </ul>

        <div className="time-estimate">
          <span className="icon"><Clock size={20} /></span>
          <span>Estimated time: {estimatedMinutes} minutes</span>
        </div>
      </div>

      <div className="important-note">
        <h4><Pin size={20} style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} /> Important:</h4>
        <p>
          This is a legally binding agreement. Please read all documents carefully
          before providing your consent. You have the right to:
        </p>
        <ul>
          <li>Withdraw your consent at any time</li>
          <li>Request a copy of your data</li>
          <li>Ask for corrections or deletion</li>
        </ul>
      </div>

      <div className="step-actions">
        <button onClick={onNext} className="btn btn-primary btn-large">
          Let Us Begin →
        </button>
      </div>

      <div className="help-text">
        <p>Need help? Contact support or read our FAQ</p>
      </div>
    </div>
  );
};

export default WelcomeStep;
